import React from 'react'

function NftCollection({username}) {
  return (
    <div>NftCollection</div>
  )
}

export default NftCollection